export const invalidNameChars = /[^\p{L}\s\-']/gu;
export const travellerNameChars = /^[\p{L}\s\-']+$/u;
export const zeroWidthChars = /[\u200B\u200C\u200D\uFEFF]/g;
export const nonBreakingSpace = /\u00A0/g;
export const multipleSpaces = /\s+/g;
export const invalidAlphanumeric = /[^a-zA-Z0-9\s]/g;
export const passportNumberReg = /[^a-zA-Z0-9]/g;
export const specialFareReg = /[^a-zA-Z0-9]+/g;
export const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const leadingSpaces = /^\s+/;
export const leadingTrailingSpaces = /^\s*|\s*$/g;
export const onlyNumber = /^\d+$/;
export const numberWithDotValue = /[^0-9.]/g;
export const allowedCharactersRegex = /^(?![IQWT\s])[A-Z0-9\-\/\s]{1,20}$/;
export const invalidCharactersRegex = /[^a-zA-Z0-9\-\/\s]/;
export const disallowedFirstCharacterRegex = /^[IQWTiqwt\s]/;
export const isdCodeRegex = /\D/g;
export const aplhaNumericDash = /[^a-zA-Z0-9\s-]/g;
export const spaceRestrict = /(^\S*$)/;
export const passRestrict = /^(?=.{0,13}$).*/;
export const isdCodeReg = /^[0-9]*$/;
export const gstNoReg = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
export const alphanumericSpecialChars = /^[ A-Za-z0-9_@./#&+-]*$/;
export const alphanumericSpecialCharsAll = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?/~`\\|=\-]*$/;
export const alphabetNameChars = /^[a-zA-Z][a-zA-Z\s]*$/;
export const phoneNoReg = /^[0-9-+()]*$/;
export const panCardReg = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const alphanumericWithUnderscore = /^[a-zA-Z0-9_]*$/;
export const alphanumeric = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;
export const alphanumericDot = /^[a-zA-Z0-9.]+$/;
export const DisallowLeadingSpace = /^(?! )[ -~]+$/
export const DisallowLeadingAndTrallingSpace = /^(?! )[ -~]+(?<! )$/
export const validEmailRegex =
  /^[^\s][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const onlyAlphabets = /^[a-zA-Z]+$/;
export const alphanumericWithSpace = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;
export const onlyNumbersRegex = /^[0-9]+$/;
export const alphabetsAndSpaces = /^[a-zA-Z][a-zA-Z\s]*$/;
export const onlyUpperCaseAlphabets = /[A-Z]/;
export const onlySpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/;
export const isdCodeRegexwithPlus = /^\+?[1-9]\d{0,3}$/;
export const disallowFirstSpace = /^[^\s].*/;
export const mobile_number = /^\d{8,16}$/;
export const validNumberWithDot = /^(\d+)?(\.\d*)?$/;
export const validPassportNumberReg = /^[A-Z0-9]{5,10}$/;
export const dobRegex =
  /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const emailValidation =
  /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[-][a-zA-Z0-9]+)*(\.[a-zA-Z0-9]+(?:[-][a-zA-Z0-9]+)*)*\.[a-zA-Z]{2,}$/;
export const nameValidation = /^[A-Za-z]+(?:\s+[A-Za-z]+)*$/;
export const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])([^\s]){0,20}$/;
export const noNumberWithCharSpace = /^(?!\s*$)[A-Za-z\s]+$/;
export const withCharSpaceBetween = /^(?!\s*$)[A-Za-z0-9\s]+$/;
export const nameDataValidation = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
export const alphanumericWithSpecialCharNoSpace = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?/~`\\|=-]*$/;
export const noLeadingSpace = /^[^\s][\s\S]*$/;
export const mobileNumberZeroRegex = /^[1-9][0-9]*$/;
export const alphabetsAndSpaceswithLength = /^(?=.{2,50}$)(?! )[A-Za-z]+(?: [A-Za-z]+)*(?<! )$/
export const alphaNumericSpaceinBetween = /^[A-Za-z]+(?: [A-Za-z]+)*\s*$/
export const emailONchange = /^[a-zA-Z0-9@.]+$/;
export const removeCommaRegex = /,/g;
export const newemailReg = /^(?!.*\.\.)[a-zA-Z0-9](\.?[a-zA-Z0-9_-])*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
export const AlphaNumericBlockSpace = /^[A-Za-z0-9]+$/;
export const digitsFollowedByUnderscoresAtEnd = /(\d+)_+$/;
export const AlphaNumericNoSpace = /^[a-zA-Z0-9]+$/
export const NameChars = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
export const noLeadingSpaceAndOnlyAlphabets = /^[A-Za-z]+(?: [A-Za-z]*)*$/;
export const latinNameChars = /^[A-Za-z\s\-'.]+$/;

export const ignoresqlInjection = /^(\d+a-\d+c(?:-\d+)*)(_\d+a-\d+c(?:-\d+)*)*$/;
export const filterNewLine = /\\n|\n/g;